// @flow
import jwtDecode from 'jwt-decode'
import { getAuthorizationToken } from '../client'

/**
 * Decodes and returns the current user email from the JWT token.
 * @return {?number} User id
 * @private
 */
function getAuthorizedUserEmail(): ?string {
  const token = getAuthorizationToken()

  if (!token) {
    return null
  }

  const decodedToken = jwtDecode(token) || {}

  return decodedToken.email || decodedToken.username
}

/**
 * Decodes and returns the current user ID from the JWT token.
 * @return {?number} User id
 * @private
 */
function getAuthorizedUserId(): ?number {
  const token = getAuthorizationToken()

  if (!token) {
    return null
  }

  const decodedToken = jwtDecode(token) || {}

  return decodedToken.user_id
}

/**
 * Check is the user is authenticated
 * @return {Boolean} Whether the user is authenticated or not
 * @private
 */
function isAuthenticated(): boolean {
  const token = getAuthorizationToken()

  if (!token) {
    return false
  }

  const { exp } = jwtDecode(token)
  const now = Math.ceil(new Date().getTime() / 1000)

  return now <= exp
}

export default {
  getAuthorizedUserId,
  isAuthenticated,
  getAuthorizedUserEmail,
}
